import { defineGfaAuthService } from '@oneaudi/audi-auth-service';
import { defineEventService } from '@oneaudi/audi-event-service';
import { defineTrackingService } from '@oneaudi/audi-tracking-service';
import { defineDealerContextService, defineGfaDealerContextService, } from '@oneaudi/dealer-context-service';
import { defineAudiDynamicFootnoteService } from '@oneaudi/dynamic-footnote-service';
import { defineAudiFootnoteService } from '@oneaudi/footnote-service';
import { defineRenderModeService } from '@oneaudi/render-mode-service';
import { defineAudiVideoService } from '@oneaudi/video-service';
import { defineDisclaimerManagers } from '@volkswagen-onehub/disclaimer-manager';
import { ecommerceFeatureServiceDefinition } from '@volkswagen-onehub/e-commerce-service';
import { defineFinancialDataService } from '@volkswagen-onehub/financial-data-feature-service';
import { gfaLayerManagerDefinition } from '@volkswagen-onehub/layer-manager';
import { createFeatureServiceBundle } from '../types/feature-service-bundle';
import { hasOverlap } from '../utils/object-overlap';
import { sharedBundle } from './shared';
export const csrOnlyBundle = createFeatureServiceBundle({
    'audi-dynamic-footnote-service': defineAudiDynamicFootnoteService,
    'audi-footnote-service': defineAudiFootnoteService,
    'audi-render-mode-service': defineRenderModeService,
    'audi-tracking-service': defineTrackingService,
    'audi-video-service': defineAudiVideoService,
    'dealer-context-service': defineDealerContextService,
    'disclaimer-manager': defineDisclaimerManagers,
    'e-commerce-service': ecommerceFeatureServiceDefinition,
    'event-service': defineEventService,
    'financial-data': defineFinancialDataService,
    'gfa:auth-service': defineGfaAuthService,
    'gfa:dealer-context-service': defineGfaDealerContextService,
    'gfa:layer-manager': gfaLayerManagerDefinition,
});
hasOverlap(csrOnlyBundle, sharedBundle, false);
export const csrBundle = {
    ...sharedBundle,
    ...csrOnlyBundle,
};
//# sourceMappingURL=csr.js.map